export const NAME = 'taskDetail';
export const KDP = 'KDP';
export const APO = 'APO';

export const SYSTEM_TYPES = [
	'TaskKvitanceAPO',
	'TaskKvitanceKDP',
	'TaskNeinKDP',
	'TaskNeplacenePS',
	'TaskRedukceKDP',
	'TaskSellerRequest',
];

export const SYSTEM_TYPES_INSURED = [
	'TaskKvitanceAPO_Insured',
	'TaskKvitanceKDP_Insured',
	'TaskNeinKDP_Insured',
	'TaskNeplacenePS_Insured',
	'TaskRedukceKDP_Insured',
	'TaskSellerRequest_Insured',
];

export const TASK_TYPES = {
	LOSE_COMISSION: 34,
	REQUEST_FOR_SELLER_CP: 12,
	EXPERATION_LIFE_INSUARANCE: 58,
	ADD_TASK_INSURANCE: 52,
};

export const TASK_STATUSES = {
	EXPIRED: 4,
};

export const dialogs = {
	errorAttachmentNotFound: `${NAME}/errorAttachmentNotFound`,
};

export const TAKE_TASK_USER_HAS_NO_ACCESS_ERR_MSG = 'Access restricted because its data';
export const TAKE_TASK_ALREADY_PROCESSED_ERR_MSG = 'User has no right to take task.';
export const HAS_NO_ACCESS_ERR_MSG = 'has no access to task';
